<arm-layout [summaryTitle]="'NODES SUMMARY'">
  <div header>
    <div class="search-container">
      <arm-search (onSearch)="onSearch($event)"
                  [searchComponent]="nodesSearchComponent"
                  [searchData]="searchData"
                  [searchTerms]="searchTerms">
      </arm-search>
    </div>

    <div class="action-buttons">

      <arm-action-bar (editClick)="editItem()" [disableEdit]="isUnauthorized || !isSingleSelection()"
                      (deleteClick)="removeItem()" [disableDelete]="isUnauthorized || !isAdminStateLocked() || !isSingleSelection()"
                      (refreshClick)="refresh()"></arm-action-bar>

      <button [matMenuTriggerFor]="menu" class="more-actions" color="primary" mat-raised-button>
        <span>Actions</span>
        <mat-icon>arrow_drop_down</mat-icon>
      </button>

      <mat-menu #menu="matMenu">
        <button (click)="syncNode()" [disabled]="isUnauthorized || !isSingleSelection()" mat-menu-item>
          <span>Sync Node</span>
        </button>
        <button (click)="lock()" [disabled]="isUnauthorized || isMixedAdminState() ||
                (this.selection && this.selection[0]?.adminState === 'LOCKED')" mat-menu-item>
          <span>Lock</span>
        </button>
        <button (click)="unlock()" [disabled]="isUnauthorized || isMixedAdminState() ||
                (this.selection && this.selection[0]?.adminState === 'UNLOCKED')" mat-menu-item>
          <span>Unlock</span>
        </button>
        <button (click)="configureNode()" [disabled]="isUnauthorized || !isSingleSelection() || isThirdPartyNode()" mat-menu-item>
          <span>Configure</span>
        </button>
        <button (click)="saveIniFile()" [disabled]="isUnauthorized || !isSingleSelection() || isThirdPartyNode()" mat-menu-item>
          <span>Save INI File</span>
        </button>

        <button (click)="openColumnsConfiguration()" mat-menu-item>
          <span>Table columns</span>
        </button>
      </mat-menu>
    </div>
  </div>
  <div summary>
    <nodes-summary [selection]="selection">
    </nodes-summary>
  </div>

  <div main>
    <arm-table [displayedColumns]="displayedColumns" (pageChanged)="pageChanged($event)"
               (onSelection)="onSelection($event)" [data]="data.elements" [length]="data.totalElements"
               [isMultipleSelection]="isMultipleSelection"
               [isClientSide]="false"></arm-table>
  </div>
</arm-layout>
